import { createReducer } from '@reduxjs/toolkit';
import { set_payment_gateway } from '../confg';

const payment_gateway = createReducer('', {
  [set_payment_gateway]: (state, action) => {
    return action.payload || '';
  },
});

export default payment_gateway;
